// extracted by mini-css-extract-plugin
export var formContainer = "_it-0";
export var message = "_it-1";